import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { collection, doc, orderBy, setDoc,query,Timestamp, getDocs, deleteDoc, where, updateDoc, writeBatch } from "@firebase/firestore"; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";


function IntakesComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    let navigate = useNavigate();
  
    const [studentsList, setStudentList] = useState([]);
    const [countAllData, setcountAllData ] = useState(0);
    const [modalShowUp, setModalShowUp] = useState(false);
    const [bulkModalShowUp, setBulkModalShowUp] = useState(false);
    const [loading, setLoading] = useState(false); 
    const [bulkLoading, setBulkLoading] = useState(false);
    const [coursesList, setCoursesList] = useState([]);
    const [selectedIntakeIds, setSelectedIntakeIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterCourse, setFilterCourse] = useState('All');
    const [filterIntakeDate, setFilterIntakeDate] = useState('');

    const courseRef = useRef();
    const campusRef = useRef();
    const intakeRef = useRef();
    const bulkIntakeRef = useRef();
  
    useEffect(() => {
      const fetchData = async () => {
          const q = query(collection(db, 'Intakes'));
          const querySnapshot = await getDocs(q);
          const studentsItem = [];
          querySnapshot.forEach((doc) => {
              studentsItem.push({ id: doc.id, ...doc.data() });
          });
          setStudentList(studentsItem);
          setcountAllData(studentsItem.length)
  
      };
  
      fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            //, orderBy("rank")
            const q = query(collection(db, 'courses'), orderBy("rank"));
            const querySnapshot = await getDocs(q);
            const studentsItem = [];
            querySnapshot.forEach((doc) => {
                studentsItem.push({ id: doc.id, ...doc.data() });
            });
            setCoursesList(studentsItem);
    
        };
    
        fetchData();
      }, []);
  

    function MyUpdateModal(props) {
        return (
          <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Add an Intake
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>

             <Form.Group className="mb-3" controlId="formCountry">
                <Form.Label>Select Course</Form.Label>
                <Form.Select aria-label="Default select example" ref={courseRef} >
                    {coursesList.map((theIntake) => (
                        <option key={theIntake.id} value={theIntake.mcourseName} >{theIntake.mcourseName}</option>
                    ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formCountry">
                <Form.Label>Select Campus</Form.Label>
                <Form.Select aria-label="Default select example"  ref={campusRef}>
                  <option value="General">All Campuses</option>
                  <option value="CBD Campus">Only CBD Campus</option>
                  <option value="Virtual Classes">Only Virtual Clases</option>
                </Form.Select>
              </Form.Group> 

              <Form.Group className="mb-3" controlId="formBranchName">
                <Form.Label>Intake Date</Form.Label>
                <Form.Control type="date" placeholder="Branch name" ref={intakeRef} />
              </Form.Group>

            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
              <Button variant="primary" onClick={submitNewIntake} disabled={loading || bulkLoading}>
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span> Sending...</span>
                  </>
                ) : (
                  'Send'
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        );
    }

    function BulkIntakeModal(props) {
        return (
          <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Add Bulk Intake
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-3" controlId="formBulkIntakeDate">
                <Form.Label>Intake Date</Form.Label>
                <Form.Control type="date" ref={bulkIntakeRef} />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
              <Button variant="secondary" onClick={submitAllOtherIntakes} disabled={loading || bulkLoading}>
                {bulkLoading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span> Sending...</span>
                  </>
                ) : (
                  'Add Bulk Intake'
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        );
    }

    function submitNewIntake(){
        const selectedCourse =  courseRef.current.value;
        const selectedCampus =  campusRef.current.value;
        const intakeDate = intakeRef.current ? intakeRef.current.value : "";
        let formattedDate;

        if (intakeDate) {
            formattedDate = formatDate(intakeDate);
          } else {
            swal("Date Error","Please select a date","error");
            return;
        }
        console.log(formattedDate);

        setLoading(true);

        const newDataRef = doc(collection(db, "Intakes"));
        setDoc(newDataRef, {
            CourseName: selectedCourse,
            Campus: selectedCampus,
            intakeDate: formattedDate,
            timeAdded: Timestamp.now(),
            docID: newDataRef.id,
            rawIntakeDate: intakeDate
        }).then(()=>{
            window.location.reload();
        })

    }

    function submitAllOtherIntakes(){
        const intakeDate = bulkIntakeRef.current ? bulkIntakeRef.current.value : "";
        let formattedDate;

        if (intakeDate) {
            formattedDate = formatDate(intakeDate);
          } else {
            swal("Date Error","Please select a date","error");
            return;
        }

        const normalizeCourseName = (courseName) => (courseName || "").toLowerCase().trim();

        const cbdOnlyCourses = new Set([
            "robotics",
            "introduction to robotics",
            "electronics & digital electronics",
            "electronics and digital electronics",
            "embedded systems with arduino (iot)",
            "embedded systems",
        ]);

        const eligibleCourses = coursesList.filter((course) => {
            const normalizedName = normalizeCourseName(course.mcourseName);
            return normalizedName;
        });

        if (eligibleCourses.length === 0) {
            swal("No Courses","No eligible courses found for 'All Other Courses'.","warning");
            return;
        }

        setBulkLoading(true);

        const batch = writeBatch(db);
        eligibleCourses.forEach((course) => {
            const newDataRef = doc(collection(db, "Intakes"));
            const normalizedName = normalizeCourseName(course.mcourseName);
            const campusValue = cbdOnlyCourses.has(normalizedName) ? "CBD Campus" : "General";
            batch.set(newDataRef, {
                CourseName: course.mcourseName,
                Campus: campusValue,
                intakeDate: formattedDate,
                timeAdded: Timestamp.now(),
                docID: newDataRef.id,
                rawIntakeDate: intakeDate
            });
        });

        batch.commit().then(()=>{
            window.location.reload();
        }).catch((error) => {
            swal("Error!", "Failed to add intakes: " + error.message, "error");
        }).finally(() => {
            setBulkLoading(false);
        });
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { month: "short" }; // Get abbreviated month name
        const month = new Intl.DateTimeFormat("en-US", options).format(date);
        const day = date.getDate();
        const daySuffix = getDaySuffix(day);
    
        return `${month} ${day}${daySuffix}`;
    };
    
    const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return "th"; // Special case for 11th, 12th, 13th
        switch (day % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
    };

    const uniqueCourses = Array.from(new Set(studentsList.map((intake) => intake.CourseName).filter(Boolean))).sort();
    const filteredIntakes = studentsList.filter((intake) => {
      const search = searchTerm.trim().toLowerCase();
      const matchesSearch = !search || [
        intake.CourseName,
        intake.Campus,
        intake.intakeDate
      ].some((value) => String(value || '').toLowerCase().includes(search));

      const matchesCourse = filterCourse === 'All' || intake.CourseName === filterCourse;

      let matchesDate = true;
      if (filterIntakeDate) {
        const rawDate = intake.rawIntakeDate || '';
        const parsed = rawDate ? new Date(rawDate) : new Date('invalid');
        const selected = new Date(filterIntakeDate);
        if (Number.isNaN(parsed.getTime())) {
          matchesDate = false;
        } else {
          matchesDate = parsed.toDateString() === selected.toDateString();
        }
      }

      return matchesSearch && matchesCourse && matchesDate;
    });
  
    function deleteIntake(intakeId) {
      swal({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this intake!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
      }).then((willDelete) => {
          if (willDelete) {
              const intakeRef = doc(db, "Intakes", intakeId);
              deleteDoc(intakeRef)
                  .then(() => {
                      swal("Poof! The intake has been deleted!", {
                          icon: "success",
                      });
                      // Remove the deleted intake from the state without refreshing
                      setStudentList((prevList) => prevList.filter((intake) => intake.id !== intakeId));
                      setcountAllData((prevCount) => prevCount - 1);
                  })
                  .catch((error) => {
                      swal("Error!", "Failed to delete intake: " + error.message, "error");
                  });
          } else {
              swal("Your intake is safe!");
          }
      });
  }

    const toggleSelectIntake = (intakeId) => {
      setSelectedIntakeIds((prev) => (
        prev.includes(intakeId)
          ? prev.filter((id) => id !== intakeId)
          : [...prev, intakeId]
      ));
    };

    const allSelectableIds = filteredIntakes
      .map((intake) => intake.docID || intake.id)
      .filter(Boolean);

    const isAllSelected = allSelectableIds.length > 0 && selectedIntakeIds.length === allSelectableIds.length;

    const toggleSelectAll = () => {
      if (isAllSelected) {
        setSelectedIntakeIds([]);
      } else {
        setSelectedIntakeIds(allSelectableIds);
      }
    };

    const deleteSelectedIntakes = async () => {
      if (selectedIntakeIds.length === 0) return;
      const confirm = await swal({
        title: "Delete selected intakes?",
        text: `This will permanently delete ${selectedIntakeIds.length} intake(s).`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (!confirm) return;

      try {
        const batch = writeBatch(db);
        selectedIntakeIds.forEach((intakeId) => {
          const intakeRef = doc(db, "Intakes", intakeId);
          batch.delete(intakeRef);
        });
        await batch.commit();
        setStudentList((prevList) => prevList.filter((intake) => !selectedIntakeIds.includes(intake.docID || intake.id)));
        setcountAllData((prevCount) => Math.max(prevCount - selectedIntakeIds.length, 0));
        setSelectedIntakeIds([]);
        swal("Deleted!", "Selected intakes have been deleted.", "success");
      } catch (error) {
        swal("Error!", "Failed to delete selected intakes: " + error.message, "error");
      }
    };
  


    return (
      <div className="clientsComp">
          <div className="dataCompTop">
            <h5>Intakes <span class="badge text-bg-warning">{countAllData}</span></h5>
    
            <div className="searchContainer">
              <div className="filterBar">
                <div className="filterInput input-group">
                  <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                  <Form.Control
                    type="text"
                    placeholder="Search course, campus, date..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="filterGroup">
                  <Form.Select className="filterSelect" value={filterCourse} onChange={(e) => setFilterCourse(e.target.value)}>
                    <option value="All">All Courses</option>
                    {uniqueCourses.map((course) => (
                      <option key={course} value={course}>{course}</option>
                    ))}
                  </Form.Select>
                  <Form.Control
                    type="date"
                    className="filterSelect"
                    value={filterIntakeDate}
                    onChange={(e) => setFilterIntakeDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button variant="outline-dark" onClick={() => navigate('/session-settings')}>
                  Session Settings
                </Button>
                <Button variant="secondary" onClick={() => setBulkModalShowUp(true)}>
                  Add Bulk Intake
                </Button>
                <button className='startOnlSessBtn' onClick={() => setModalShowUp(true)}>
                    <FontAwesomeIcon icon={faPlus} className="liveSessionIcon" /> Add an Intake
                </button>
                <button
                  className='btn btn-outline-danger'
                  onClick={deleteSelectedIntakes}
                  disabled={selectedIntakeIds.length === 0}
                >
                  Delete Selected ({selectedIntakeIds.length})
                </button>
              </div>
            </div>
  
          </div>
    
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>
                  <Form.Check
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={toggleSelectAll}
                    aria-label="Select all intakes"
                  />
                </th>
                <th>Intake Date</th>
                <th>Course Name</th>
                <th>Campus</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {filteredIntakes.map((theIntake) => (
                <tr key={theIntake.id}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedIntakeIds.includes(theIntake.docID || theIntake.id)}
                      onChange={() => toggleSelectIntake(theIntake.docID || theIntake.id)}
                      aria-label={`Select ${theIntake.CourseName} intake`}
                    />
                  </td>
                  <td>{theIntake.intakeDate}</td>
                  <td>{theIntake.CourseName}</td>
                  <td>{theIntake.Campus}</td>
                  <td><button className='btn btn-sm btn-primary' onClick={() => deleteIntake(theIntake.docID)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </Table>

          <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
          <BulkIntakeModal show={bulkModalShowUp} onHide={() => setBulkModalShowUp(false)} />
        </div>
  
    )
  } 

export default IntakesComp
